<section class="anim-loading" *appAdminPermission="['ViewAppraisal'];">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h2 i18n>Certificado de Aferição</h2>
      </div>
      <div class="col-md-6 d-flex justify-content-end">
        <div *ngIf="gb.isOn('ECS-3235')">
          <button i18n type="button" class="btn btn-fade-primary"
            title="Cadastrar Certificado"
            (click)="openCreateOrUpdateAppraisal()"
            *appAdminPermission="['CreateAppraisal']">Novo Certificado</button>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <button type="button" class="btn mr-1"
        [ngClass]="viewMode === 'contrato' ? 'btn-info' : 'btn-outline-secondary'"
        (click)="setViewMode('contrato')" i18n>Contrato</button>
      <button type="button" class="btn"
        [ngClass]="viewMode === 'ensaio' ? 'btn-info' : 'btn-outline-secondary'"
        (click)="setViewMode('ensaio')" i18n>Código do Ensaio</button>
    </div>

    <div class="row my-3">
      <div class="col-md-12">
      <form [formGroup]="searchForm">
        <div class="input-group">
          <input type="text" class="form-control form-search"
            placeholder="Buscar Registro" formControlName="search"
            autocomplete="off" (input)="handleSearch($event)">
          <div class="input-group-append">
            <div class="filter-dropdown">
              <button type="button"
                class="btn btn-outline-secondary btn-icon filter-dropdown__handle"
                i18n>
                <i class="material-icons">filter_alt</i> Filtrar</button>
              <div class="filter-dropdown__content">
                <div class="form-group">
                  <app-input type="select" [list]="spots" label="Ponto"
                    formControlName="spotId"
                    selectText="prettyName" selectValue="id"
                    placeholder="Selecione o ponto" i18n-placeholder
                    i18n-label>
                  </app-input>
                </div>
                <div class="form-group">
                  <app-input type="select" [list]="lanes" label="Faixa"
                    formControlName="laneId"
                    selectText="prettyNames" selectValue="id"
                    placeholder="Selecione a faixa" i18n-placeholder
                    i18n-label>
                  </app-input>
                </div>
                <div class="form-group">
                  <app-input type="select" [list]="equipments"
                    label="Série do equipamento" formControlName="equipmentId"
                    selectText="serialNumber" selectValue="id"
                    placeholder="Selecione a Série" i18n-placeholder
                    i18n-label>
                  </app-input>
                </div>
                <div class="filter-dropdown__footer">
                  <button i18n type="submit" class="btn btn-info btn-block"
                    (click)="handleSearch($event)"
                    data-dismiss="modal">Aplicar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="!loading && viewMode === 'contrato'">
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-3"
          *ngFor="let appraisalContractCard of appraisalContractCards">
          <div class="card-body">
            <div
              class="button d-flex justify-content-between align-items-center">
              <div class="text">
                <h4 i18n>{{ appraisalContractCard?.contractId }} - {{
                  appraisalContractCard?.contractName }}</h4>
                <p i18n>{{ appraisalContractCard?.appraisalLength }}
                  Certificados</p>
              </div>
              <div class="expand"
                (click)="openOrCLoseAppraisalContractCard(appraisalContractCard)">
                <button class="btn text-secondary btn-icon-block"><i
                    class="material-icons">
                    {{ appraisalContractCard?.isOpen ? 'unfold_less' :
                    'unfold_more' }}</i>
                </button>
              </div>
            </div>
            <div class="content pt-3" *ngIf="appraisalContractCard?.isOpen">
              <!-- spotCard -->
              <div class="card bg-gray--150 mb-2"
                *ngFor="let appraisalSpotCard of appraisalContractCard.spotCardsPaginated">
                <div
                  class="card-body d-flex justify-content-between align-items-center">
                  <p class="mb-0" i18n>Ponto: {{
                    spotsById[appraisalSpotCard?.spotId]?.code }} - {{
                    spotsById[appraisalSpotCard?.spotId]?.description ||
                    spotsById[appraisalSpotCard?.spotId]?.address?.street }}</p>
                  <button class="btn text-secondary btn-icon-block"
                    (click)="openOrCloseAppraisalSpotCard(appraisalSpotCard)">
                    <i class="material-icons">
                      {{ appraisalSpotCard?.isOpen ? 'unfold_less' :
                      'unfold_more'
                      }}
                    </i>
                  </button>
                </div>
                <div class="spot-card-content bg-light"
                  *ngIf="appraisalSpotCard?.isOpen">
                  <table
                    class="table table-bordeless table-striped table-hover data-table">
                    <thead>
                      <tr>
                        <th>Faixa</th>
                        <th>Código do Ensaio</th>
                        <th>Data do Ensaio</th>
                        <th>Série</th>
                        <th>Modelo de Eqto</th>
                        <th>Vigência</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let appraisal of appraisalSpotCard?.appraisals">
                        <td>{{ appraisal?.AppraisalLane?.code }}</td>
                        <td>CE{{ appraisal?.experimentCode }}</td>
                        <td>{{ appraisal?.experimentDate | moment: 'L' }}</td>
                        <td>{{ appraisal?.AppraisalEquipment?.serialNumber }}</td>
                        <td>{{ appraisal?.AppraisalEquipment?.modelName }}</td>
                        <td>{{ appraisal?.validateInitial | moment: 'L' }}</td>
                        <td>
                          <div class="dropdown">
                            <button class="btn btn-icon-block" type="button"
                              id="dropdownMenuButton" data-toggle="dropdown"
                              aria-haspopup="true" aria-expanded="false"
                              [disabled]="!canEdit">
                              <i class="material-icons">more_horiz</i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right"
                              aria-labelledby="dropdownMenuButton">
                              <span>
                                <a class="dropdown-item"
                                  (click)="openCreateOrUpdateAppraisal(appraisal)"
                                  *appAdminPermission="['UpdateAppraisal']">Editar
                                  Certificado</a>
                                <a class="dropdown-item"
                                  (click)="openAppraisalMeasurements(appraisal)"
                                  *appAdminPermission="['UpdateAppraisal']">Editar
                                  Registro de Medição</a>
                                <span *ngIf="!gb.isOn('EM-414')">
                                  <a class="dropdown-item"
                                    (click)="downloadAppraisalPDF(appraisal)"
                                    *appAdminPermission="['UpdateAppraisal']">Exportar
                                    Certificado de Aferição
                                  </a>
                                </span>
                                <span *ngIf="!gb.isOn('EM-414')">
                                  <a class="dropdown-item"
                                    (click)="downloadMeasurementsPDF(appraisal)"
                                    *appAdminPermission="['UpdateAppraisal']">Exportar
                                    Registro de Medição
                                  </a>
                                </span>
                                <span *ngIf="gb.isOn('EM-414')">
                                  <a class="dropdown-item"
                                    (click)="openDownloadModal(appraisal)"
                                    *appAdminPermission="['UpdateAppraisal']">
                                    Exportar
                                  </a>
                                </span>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- end spotCard -->
              <app-pagination-simple
                (items)="setSpotCardsPaginated(appraisalContractCard, $event)"
                [data]="appraisalContractCard?.spotCards"></app-pagination-simple>
            </div>
          </div>
        </div>
        <p class="text-secondary text-center py-5"
          *ngIf="appraisalContractCards.length === 0" i18n>Não foram encontrados
          registros para o filtro aplicado.</p>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="!loading && viewMode === 'ensaio'">
    <div class="table-responsive table-hover table-block" *ngIf="appraisalsFlatList.length > 0">
      <table class="table bg-white">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSortExperimentCode()">
              Código do Ensaio
              <i class="material-icons sort-icon">{{ sortExperimentCodeOrder === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</i>
            </th>
            <th i18n>Contrato</th>
            <th i18n>Ponto</th>
            <th i18n>Faixa</th>
            <th i18n>Data do Ensaio</th>
            <th i18n>Serie</th>
            <th i18n>Modelo do Eqto</th>
            <th i18n>Validade</th>
            <th i18n>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let appraisal of appraisalsFlatListPaginated">
            <td>CE{{ appraisal?.experimentCode }}</td>
            <td>{{ contractsById[appraisal?.contractId]?.code }} - {{ contractsById[appraisal?.contractId]?.name }}</td>
            <td><span class="badge badge-dark badge-spot">{{ spotsById[appraisal?.spotId]?.code }}</span></td>
            <td><span class="badge badge-fade-secondary badge-lane">{{ appraisal?.AppraisalLane?.code }}</span></td>
            <td>{{ appraisal?.experimentDate | moment: 'L' }}</td>
            <td>{{ appraisal?.AppraisalEquipment?.serialNumber }}</td>
            <td>{{ appraisal?.AppraisalEquipment?.modelName }}</td>
            <td>{{ appraisal?.validateInitial | moment: 'L' }}</td>
            <td>
              <div class="dropdown">
                <button class="btn btn-icon-block" type="button"
                  id="dropdownMenuButtonFlat" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false"
                  [disabled]="!canEdit">
                  <i class="material-icons">more_horiz</i>
                </button>
                <div class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButtonFlat">
                  <span>
                    <a class="dropdown-item"
                      (click)="openCreateOrUpdateAppraisal(appraisal)"
                      *appAdminPermission="['UpdateAppraisal']">Editar Certificado</a>
                    <a class="dropdown-item"
                      (click)="openAppraisalMeasurements(appraisal)"
                      *appAdminPermission="['UpdateAppraisal']">Editar Registro de Medição</a>
                    <span *ngIf="!gb.isOn('EM-414')">
                      <a class="dropdown-item"
                        (click)="downloadAppraisalPDF(appraisal)"
                        *appAdminPermission="['UpdateAppraisal']">Exportar Certificado de Aferição</a>
                    </span>
                    <span *ngIf="!gb.isOn('EM-414')">
                      <a class="dropdown-item"
                        (click)="downloadMeasurementsPDF(appraisal)"
                        *appAdminPermission="['UpdateAppraisal']">Exportar Registro de Medição</a>
                    </span>
                    <span *ngIf="gb.isOn('EM-414')">
                      <a class="dropdown-item"
                        (click)="openDownloadModal(appraisal)"
                        *appAdminPermission="['UpdateAppraisal']">Exportar</a>
                    </span>
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="text-secondary text-center py-5"
      *ngIf="appraisalsFlatList.length === 0" i18n>Não foram encontrados registros para o filtro aplicado.</p>
    <app-pagination-simple
      (items)="setFlatListPaginated($event)"
      [data]="appraisalsFlatList"></app-pagination-simple>
  </div>

  <div class="loading-page" *ngIf="loading">
    <div class="loading-spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</section>
